'use client'
import { useState, type HTMLAttributes } from 'react';
import dynamic from 'next/dynamic';

import { Button } from '@/stories/atoms/Button/Button';
import { Icon } from '@/stories/atoms/Icon/Icon';
import { Modal } from '@/stories/organisms/Modal/Modal';
import { Loader } from '@/stories/atoms/Loader/Loader';
import { Card } from '../Card/Card';

// chargé à l'ouverture : le formulaire embarque zod et react-hook-form (~30 KB gzip)
const CollabContactForm = dynamic(
  () => import('./CollabContactFrom').then(m => m.CollabContactForm),
  { ssr: false, loading: () => <Loader /> }
)

export type CollabContactProps = {
  agence: string
  collabId: string
} & HTMLAttributes<HTMLElement>

export const CollabContactModal = ({ agence, collabId }: CollabContactProps) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button variant='secondary' onClick={() => setOpen(true)}>
        <Icon icon='envelope'/><span className='sr-only'>Contact</span>
      </Button>
      {open ? (
        <Modal open={open} onClose={() => setOpen(false)}>
          <Card background='grey-light'>
            <CollabContactForm agence={agence} collabId={collabId}/>
          </Card>
        </Modal>
      ) : null}
    </>
  )
};
